/* eslint-disable import/prefer-default-export */
export var MIN_QUERY_LENGTH = 4;